import React from 'react'
import PropTypes from 'prop-types'
import {Text, Box} from '@chakra-ui/react'

export const TextTitle = ({
    alignment = 'left',
    as = 'h2',
    textStyle = 'body-medium',
    color = 'text.secondary',
    weight = '400',
    ...props
}) => {
    return (
        <Box {...props}>
            <Text
                as={as}
                textAlign={alignment}
                textStyle={textStyle}
                fontWeight={weight}
                color={color}
            >
                {props.children}
            </Text>
        </Box>
    )
}

TextTitle.propTypes = {
    as: PropTypes.string,
    alignment: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    textStyle: PropTypes.string,
    weight: PropTypes.string,
    color: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}
